/* eslint-disable */
const spacename = 'record-application';
const CHANGE_TABLE_DATA = `${spacename}change_table_data`;
export { CHANGE_TABLE_DATA };
